export class MediaAxios {
  static getImageUrl(
    imageId: string,
    query?: Record<string, string | number | boolean | undefined>,
  ): string {
    return `${process.env.REACT_APP_API_URL}/media/${imageId}${query ? `?${new URLSearchParams(query as Record<string, string>).toString()}` : ""}`;
  }
}
